module.exports = __webpack_public_path__ + "static/media/IconTemplates_-101.3ad48bcd.jpg";